module.exports = function() {
  return new Worker(__webpack_public_path__ + "3d7857b1de5e988010ee.worker.js");
};